module.exports = __webpack_public_path__ + "img/SS.3de5768e.png";